export default __webpack_public_path__ + "static/bed-bath-beyond-7-c-968e466ec836c0021b31c8f410523944.gif";